import React, { useEffect, useState, useRef } from 'react';
import { getHighlight } from '../Service/Api';

const Highlights = () => {
    const [data, setData] = useState([]);
    const marqueeRef = useRef(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getHighlight();
                setData(Array.isArray(response) && response.length ? response : []);
            } catch (error) {
                console.error("Error fetching highlights:", error);
            }
        };
        fetchData();
    }, []);

    const fallbackData = [
        {
            title: "Stay tuned",
            description: "Stay tuned for latest updates",
            fromDate: "",
            attachments: []
        }
    ];

    const highlights = data.length ? data : fallbackData;

    const highlightText = highlights.map((item) => {
        const hasAttachment = item.attachments && item.attachments.length > 0;
        const attachmentLink = hasAttachment
            ? `<a href="https://webapi.entab.info/api/image/${item.attachments[0]}" target="_blank" title="View Attachment" style="margin-right: 5px;"><i class='bi bi-paperclip'></i></a>`
            : '';
        return `${attachmentLink}${item.title}`;
    }).join(' &nbsp;&nbsp;|&nbsp;&nbsp; ');

    const handleMouseOver = () => {
        if (marqueeRef.current) {
            marqueeRef.current.stop();
        }
    };

    const handleMouseOut = () => {
        if (marqueeRef.current) {
            marqueeRef.current.start();
        }
    };

    return (
        <div className="highlight">
            <marquee
                ref={marqueeRef}
                behavior="scroll"
                direction="left"
                scrollAmount="5"
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                dangerouslySetInnerHTML={{ __html: highlightText }}
            />
        </div>
    );
};

export default Highlights;
